export default __webpack_public_path__ + "static/media/tab-connect-dashboard.cef9daef.png";